// scroll_page client tool — the agent walks a page like a person giving a
// demo: a slow deliberate glide (duration scales with distance), not the
// browser's quick smooth-scroll. "next"/"prev" step through the page's
// <section> elements in order (no anchor ids needed), "top"/"bottom" jump,
// anything else is an element id (polled briefly — the target may still be
// mounting after a navigate_app). Same choreography as the Anastasia concierge.
const HEADER_OFFSET = 72;

export function glideTo(y) {
  const start = window.scrollY;
  const max = document.documentElement.scrollHeight - window.innerHeight;
  const delta = Math.max(0, Math.min(y, max)) - start;
  if (Math.abs(delta) < 4) return;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, start + delta);
    return;
  }
  const ms = Math.max(700, Math.min(1800, Math.abs(delta) * 0.9));
  const t0 = performance.now();
  const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - ((-2 * t + 2) ** 2) / 2);
  const step = (now) => {
    const p = Math.min(1, (now - t0) / ms);
    window.scrollTo(0, start + delta * ease(p));
    if (p < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}

export function scrollToId(id, attemptsLeft = 40) {
  const el = document.getElementById(id);
  if (el) {
    glideTo(el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET);
    return;
  }
  if (attemptsLeft > 0) setTimeout(() => scrollToId(id, attemptsLeft - 1), 50);
}

export function scrollPage(target) {
  const t = String(target || '').trim();
  if (t === 'top') return glideTo(0);
  if (t === 'bottom') return glideTo(document.documentElement.scrollHeight);
  if (t === 'next' || t === 'prev') {
    const tops = [...document.querySelectorAll('section')]
      .filter((s) => s.offsetParent !== null && s.offsetHeight > 120)
      .map((s) => s.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET)
      .sort((a, b) => a - b);
    const cur = window.scrollY;
    const y = t === 'next'
      ? tops.find((v) => v > cur + 60)
      : [...tops].reverse().find((v) => v < cur - 60);
    if (y != null) return glideTo(y);
    return glideTo(t === 'next' ? cur + window.innerHeight * 0.85 : Math.max(0, cur - window.innerHeight * 0.85));
  }
  return scrollToId(t);
}

export function safeSection(id) {
  const s = String(id || '').trim();
  return /^[\w-]{1,64}$/.test(s) ? s : '';
}
